<template>
    <main class="main z-10 mt-16 md:mt-20 lg:mt-0">
        <!--  <router-view :key="$route.fullPath"/>-->
        <router-view/>
    </main>
</template>

<script>
export default {
    name: "Main"
}
</script>

<style scoped lang="scss"></style>
